"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerAssignmentQuery = exports.ContainerAssignmentUpdate = exports.ContainerAssignmentCreate = exports.ContainerAssignmentTransport = exports.AssignmentTypeLabels = exports.AssignmentType = exports.AssignmentTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const container_1 = require("./container");
const container_type_1 = require("./container-type");
exports.AssignmentTypes = ['DECOMMISSIONED', 'CUSTOMER', 'OUT_OF_SERVICE'];
exports.AssignmentType = typebox_1.Type.Union(exports.AssignmentTypes.map((type) => typebox_1.Type.Literal(type)));
exports.AssignmentTypeLabels = {
    DECOMMISSIONED: 'Decommissioned',
    CUSTOMER: 'Customer',
    OUT_OF_SERVICE: 'Out of Service',
};
exports.ContainerAssignmentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    container: typebox_1.Type.Optional(container_1.ContainerTransport),
    containerType: container_type_1.ContainerTypeTransport,
    quantity: typebox_1.Type.Integer(),
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    type: exports.AssignmentType,
    references: typebox_1.Type.Array(common_1.EntityReference),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    address: typebox_1.Type.Optional(common_1.AddressTransport),
    metadata: common_1.MetaData,
});
exports.ContainerAssignmentCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ContainerAssignmentTransport, ['id', 'metadata', 'container', 'references', 'containerType']),
    typebox_1.Type.Object({
        containerTypeID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        container: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        references: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.EntityReference)),
    }),
]);
exports.ContainerAssignmentUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    exports.ContainerAssignmentCreate,
    typebox_1.Type.Object({
        completedAt: typebox_1.Type.String({ format: 'date-time' }),
    }),
]));
exports.ContainerAssignmentQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        containerID: typebox_1.Type.String({ format: 'uuid' }),
        referencesEntityType: common_1.EntityType,
        referencesEntityID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
//# sourceMappingURL=container-assignment.js.map